'use strict';
'use es6';

// These should be removed once we have 100% adoption of UIApplication

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

require('../../listeners/focusStylesListener');

var _setupStyledComponents = require('../../listeners/setupStyledComponents');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _SimpleDate = require('../../core/SimpleDate');

var _SimpleDateTypes = require('../../types/SimpleDateTypes');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactUtils = require('react-utils');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _UIPopover = require('../../tooltip/UIPopover');

var _UIPopover2 = _interopRequireDefault(_UIPopover);

var _SyntheticEvent = require('../../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _Functions = require('../../core/Functions');

var _createLazyPropType = require('../../utils/propTypes/createLazyPropType');

var _createLazyPropType2 = _interopRequireDefault(_createLazyPropType);

var _RootNode = require('../../utils/RootNode');

var _lazyEval = require('../../utils/lazyEval');

var _lazyEval2 = _interopRequireDefault(_lazyEval);

var _Dom = require('../../utils/Dom');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

(0, _setupStyledComponents.setupStyledComponents)();

var EMPTY_REGEX = /^\s*$/;

var cachedPlaceholder = void 0;

var getPlaceholder = function getPlaceholder() {
  if (cachedPlaceholder != null) {
    return cachedPlaceholder;
  }

  // Look up the proper long date format in this locale
  var localeData = (_I18n2.default.moment.localeData || _I18n2.default.moment.langData)();
  if (localeData && localeData._longDateFormat && localeData._longDateFormat.L) {
    cachedPlaceholder = localeData._longDateFormat.L;
    return cachedPlaceholder;
  }

  // Fallback, just in case Moment behaves unexpectedly
  return 'MM/DD/YYYY';
};

var getValueIsValid = function getValueIsValid(value) {
  return !value || (0, _SimpleDate.isValid)(value);
};

var getBoundedValue = function getBoundedValue(value, minValue, maxValue) {
  if (minValue != null && value != null && (0, _SimpleDate.compare)(value, minValue) === -1) {
    return minValue;
  } else if (maxValue != null && value != null && (0, _SimpleDate.compare)(value, maxValue) === 1) {
    return maxValue;
  }
  return value;
};

var getValueIsInBounds = function getValueIsInBounds(value, minValue, maxValue) {
  return getBoundedValue(value, minValue, maxValue) === value;
};

var getReadableDate = function getReadableDate(format, value) {
  if (!getValueIsValid(value)) {
    return _I18n2.default.text('salesUI.UIAbstractDateInput.invalidDate');
  }
  if (!value) {
    return '';
  }
  return (0, _SimpleDate.toMoment)(value).format(format);
};

exports.default = _react2.default.createClass({
  displayName: 'UIAbstractDateInput',

  propTypes: {
    children: _react.PropTypes.func.isRequired,
    className: _react.PropTypes.string,
    clearable: _react.PropTypes.bool,
    clearLabel: _react.PropTypes.string,
    datepickerClassName: _react.PropTypes.string,
    disabledValues: _react.PropTypes.arrayOf(_SimpleDateTypes.SimpleDateType),
    error: _react.PropTypes.bool,
    format: _react.PropTypes.string,
    maxValue: _SimpleDateTypes.SimpleDateType,
    maxValueValidationMessage: (0, _createLazyPropType2.default)(_react.PropTypes.string),
    minValue: _SimpleDateTypes.SimpleDateType,
    minValueValidationMessage: (0, _createLazyPropType2.default)(_react.PropTypes.string),
    onBlur: _react.PropTypes.func,
    onChange: _react.PropTypes.func.isRequired,
    onFocus: _react.PropTypes.func,
    onMouseDown: _react.PropTypes.func,
    placeholder: (0, _createLazyPropType2.default)(_react.PropTypes.string),
    readOnly: _react.PropTypes.bool,
    todayLabel: _react.PropTypes.string,
    value: _SimpleDateTypes.SimpleDateType,
    _bodyElement: _react.PropTypes.instanceOf(HTMLElement)
  },

  getDefaultProps: function getDefaultProps() {
    return {
      clearable: true,
      format: 'L',
      minValueValidationMessage: function minValueValidationMessage() {
        return _I18n2.default.text('salesUI.UIAbstractDateInput.dateBelowMin');
      },
      maxValueValidationMessage: function maxValueValidationMessage() {
        return _I18n2.default.text('salesUI.UIAbstractDateInput.dateAboveMax');
      },
      placeholder: getPlaceholder
    };
  },
  getInitialState: function getInitialState() {
    return {
      hasFocus: false,
      isPickerOpen: false,
      userTextInput: ''
    };
  },
  componentWillMount: function componentWillMount() {
    if (!_jquery2.default.fn.pickadate) {
      _devLogger2.default.warn({
        message: 'UIAbstractDateInput: Pickadate not loaded. See https://git.hubteam.com/HubSpot/UIComponents/issues/2160',
        key: 'UIAbstractDateInput:PickadateNotLoaded'
      });
    }
    /* eslint-disable hubspot-is-special */
    if (!window.hubspot.baldric) {
      _devLogger2.default.warn({
        message: 'UIAbstractDateInput: Baldric not loaded. See https://git.hubteam.com/HubSpot/UIComponents/issues/2160',
        key: 'UIAbstractDateInput:BaldricNotLoaded'
      });
    }
    /* eslint-enable hubspot-is-special */
  },
  componentDidMount: function componentDidMount() {
    /* eslint-disable react/no-did-mount-set-state */
    if (!this._el) return;

    // Check if we've been autoFocused and, if so, update state to reflect that.
    var hasFocus = this._el.contains(document.activeElement);
    if (hasFocus && !this.state.hasFocus) {
      this.setState(_extends({
        hasFocus: true
      }, this.getOpenState()));
    }
    /* eslint-enable react/no-did-mount-set-state */
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    if (!prevState.isPickerOpen && this.state.isPickerOpen) {
      this.initPickadate();
    } else if (prevState.isPickerOpen && !this.state.isPickerOpen) {
      this.destroyPickadate();
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    var _bodyElement = this.props._bodyElement;

    this.destroyPickadate();
    if (this._tooltipRootEl) {
      (_bodyElement || (0, _RootNode.getDefaultNode)()).removeChild(this._tooltipRootEl);
    }
  },
  focus: function focus() {
    if (this._input != null) {
      this._input.focus();
    }
  },
  select: function select() {
    if (this._input != null) {
      this._input.select();
    }
  },
  initPickadate: function initPickadate() {
    var _props = this.props,
        clearLabel = _props.clearLabel,
        minValue = _props.minValue,
        maxValue = _props.maxValue,
        disabledValues = _props.disabledValues,
        readOnly = _props.readOnly,
        todayLabel = _props.todayLabel,
        value = _props.value;


    if (readOnly) {
      return;
    }

    if (this.getPicker()) {
      return;
    }

    var containerEl = (0, _reactDom.findDOMNode)(this._container);
    if (!containerEl) {
      return;
    }

    var disabledArr = void 0;

    if (disabledValues) {
      disabledArr = disabledValues.map(_SimpleDate.toArray);
    }

    this.$getPickerNode().pickadate({
      container: containerEl,
      onSet: this.handlePickadateChange,
      onClose: this.handlePickadateClose,
      editable: false,
      min: (0, _SimpleDate.toArray)(minValue) || undefined,
      max: (0, _SimpleDate.toArray)(maxValue) || undefined,
      disable: disabledArr,
      today: todayLabel,
      clear: clearLabel,
      select: (0, _SimpleDate.toArray)(value)
    });
  },
  destroyPickadate: function destroyPickadate() {
    var picker = this.getPicker();
    if (picker) {
      picker.stop();
    }
  },
  getPicker: function getPicker() {
    return this.$getPickerNode().pickadate('picker');
  },
  $getPickerNode: function $getPickerNode() {
    var $node = (0, _jquery2.default)((0, _reactDom.findDOMNode)(this._input));
    if ($node.is('input')) {
      return $node;
    }
    return $node.find('input');
  },
  getOpenState: function getOpenState() {
    return {
      isPickerOpen: true
    };
  },
  getClosedState: function getClosedState() {
    var _props2 = this.props,
        format = _props2.format,
        value = _props2.value;

    return {
      isPickerOpen: false,
      userTextInput: getReadableDate(format, value)
    };
  },
  triggerChange: function triggerChange(newValue) {
    var _props3 = this.props,
        maxValue = _props3.maxValue,
        minValue = _props3.minValue,
        onChange = _props3.onChange,
        value = _props3.value;


    if (newValue === null && value !== newValue) {
      onChange((0, _SyntheticEvent2.default)(null));
    }

    var boundedNewValue = getBoundedValue(newValue, minValue, maxValue);
    if ((0, _SimpleDate.equals)(boundedNewValue, value)) return;
    onChange((0, _SyntheticEvent2.default)(boundedNewValue));
  },
  handleKeyDown: function handleKeyDown(evt) {
    if (evt.key === 'Enter') {
      this.setState(_extends({}, this.getOpenState()));
    }
  },
  handleKeyUp: function handleKeyUp(evt) {
    if (evt.key === 'Enter') {
      evt.preventDefault();
      evt.stopPropagation();
    }
  },
  handlePickadateChange: function handlePickadateChange() {
    var pickadateVal = this.getPicker().get('select');
    var newValue = pickadateVal && (0, _SimpleDate.fromPickadate)(pickadateVal);
    this.triggerChange(newValue);
  },
  handlePickadateClose: function handlePickadateClose() {
    var _props4 = this.props,
        format = _props4.format,
        value = _props4.value;

    var input = this.$getPickerNode()[0];
    if (input) {
      input.value = getReadableDate(format, value); // replace Pickadate-set value
    }
    this.setState(_extends({}, this.getClosedState()));
  },
  handleChange: function handleChange(evt) {
    if (this.props.readOnly) {
      return;
    }
    var userTextInput = evt.target.value;
    this.handleUserTextInput(userTextInput);
  },
  handlePaste: function handlePaste(evt) {
    try {
      var userTextInput = evt.nativeEvent.clipboardData.getData('text/plain');
      this.handleUserTextInput(userTextInput);
    } catch (error) {
      /* Browser is being weird, just ignore it */
    }
  },
  handleUserTextInput: function handleUserTextInput(userTextInput) {
    var rawMoment = _I18n2.default.moment(userTextInput, this.props.format);
    var newValue = EMPTY_REGEX.test(userTextInput) ? null : (0, _SimpleDate.fromMoment)(rawMoment);
    if (getValueIsValid(newValue)) {
      this.triggerChange(newValue);
    }
    this.setState({
      userTextInput: userTextInput
    });
  },
  handleBlur: function handleBlur(evt) {
    var onBlur = this.props.onBlur;

    this.setState({
      hasFocus: false
    });
    (0, _Functions.callIfPossible)(onBlur, evt);
  },
  handleFocus: function handleFocus(evt) {
    var onFocus = this.props.onFocus;

    this.setState(_extends({
      hasFocus: true
    }, this.getOpenState()));
    (0, _Functions.callIfPossible)(onFocus, evt);
  },
  handleMouseDown: function handleMouseDown(evt) {
    // While the input has focus, mousedown should toggle the picker
    var onMouseDown = this.props.onMouseDown;

    if (this.state.hasFocus) {
      if (this.state.isPickerOpen) {
        this.setState(_extends({}, this.getClosedState()));
      } else {
        this.setState(_extends({}, this.getOpenState()));
      }
    }
    (0, _Functions.callIfPossible)(onMouseDown, evt);
  },
  handleContainerMouseenter: function handleContainerMouseenter(evt) {
    // If the mouse is within a disabled day, we want to show a tooltip to explain why it's disabled.
    var _props5 = this.props,
        minValue = _props5.minValue,
        minValueValidationMessage = _props5.minValueValidationMessage,
        maxValue = _props5.maxValue,
        maxValueValidationMessage = _props5.maxValueValidationMessage;

    var disabledDateEl = (0, _Dom.closest)(evt.target, '.picker__day--disabled');
    if (disabledDateEl) {
      var dateTimestamp = +disabledDateEl.getAttribute('data-pick');
      if (minValue != null && dateTimestamp < (0, _SimpleDate.toMoment)(minValue).valueOf()) {
        this.attachTooltip(disabledDateEl, (0, _lazyEval2.default)(minValueValidationMessage));
      } else if (maxValue != null && dateTimestamp > (0, _SimpleDate.toMoment)(maxValue).valueOf()) {
        this.attachTooltip(disabledDateEl, (0, _lazyEval2.default)(maxValueValidationMessage));
      }
    }
  },
  attachTooltip: function attachTooltip(target, message) {
    var _this = this;

    // We have to mount a new React tree to hold our UIPopover, though it won't actually have any content.
    var _bodyElement = this.props._bodyElement;

    if (!this._tooltipRootEl) {
      this._tooltipRootEl = document.createElement('div');
      (_bodyElement || (0, _RootNode.getDefaultNode)()).appendChild(this._tooltipRootEl);
    }

    // We can't use UITooltip here because that component's target must be its child.
    var popover = _react2.default.createElement(_UIPopover2.default, {
      open: true,
      use: 'tooltip',
      target: target,
      content: _react2.default.createElement(
        'div',
        { className: 'private-tooltip__inner' },
        message
      )
    });
    _reactDom2.default.render(popover, this._tooltipRootEl);
    target.addEventListener('mouseleave', function () {
      _reactDom2.default.unmountComponentAtNode(_this._tooltipRootEl);
    });
  },
  refCallback: function refCallback(ref) {
    this._el = ref;
  },
  containerRefCallback: function containerRefCallback(ref) {
    this._container = ref;

    if (ref) {
      ref.addEventListener('mouseenter', this.handleContainerMouseenter, true);

      if (this.state.isPickerOpen) {
        this.initPickadate();
      }
    }
  },
  inputRefCallback: function inputRefCallback(ref) {
    this._input = ref;
  },
  renderChild: function renderChild(_ref) {
    var children = _ref.children,
        error = _ref.error,
        format = _ref.format,
        maxValue = _ref.maxValue,
        minValue = _ref.minValue,
        placeholder = _ref.placeholder,
        readOnly = _ref.readOnly,
        rest = _ref.rest,
        value = _ref.value;

    (0, _reactUtils.invariant)(typeof children === 'function', 'UIAbstractDateInput: this.props.children must be a function but got %s', children);

    var _state = this.state,
        hasFocus = _state.hasFocus,
        isPickerOpen = _state.isPickerOpen,
        userTextInput = _state.userTextInput;

    var userIsTyping = hasFocus && !isPickerOpen;

    return children(_extends({}, rest, {
      'aria-invalid': error === true || !getValueIsValid(value) || !getValueIsInBounds(value, minValue, maxValue),
      'data-format': getPlaceholder(),
      isPickerOpen: isPickerOpen,
      onBlur: this.handleBlur,
      onFocus: this.handleFocus,
      onChange: this.handleChange,
      onMouseDown: this.handleMouseDown,
      onPaste: this.handlePaste,
      placeholder: (0, _lazyEval2.default)(placeholder),
      readOnly: readOnly,
      ref: this.inputRefCallback,
      value: userIsTyping ? userTextInput : getReadableDate(format, value)
    }));
  },
  render: function render() {
    var _props6 = this.props,
        _bodyElement = _props6._bodyElement,
        children = _props6.children,
        className = _props6.className,
        clearable = _props6.clearable,
        datepickerClassName = _props6.datepickerClassName,
        __disabledValues = _props6.disabledValues,
        error = _props6.error,
        format = _props6.format,
        minValue = _props6.minValue,
        __minValueValidationMessage = _props6.minValueValidationMessage,
        maxValue = _props6.maxValue,
        __maxValueValidationMessage = _props6.maxValueValidationMessage,
        __onBlur = _props6.onBlur,
        __onChange = _props6.onChange,
        __onFocus = _props6.onFocus,
        placeholder = _props6.placeholder,
        readOnly = _props6.readOnly,
        value = _props6.value,
        rest = _objectWithoutProperties(_props6, ['_bodyElement', 'children', 'className', 'clearable', 'datepickerClassName', 'disabledValues', 'error', 'format', 'minValue', 'minValueValidationMessage', 'maxValue', 'maxValueValidationMessage', 'onBlur', 'onChange', 'onFocus', 'placeholder', 'readOnly', 'value']);

    return (
      /* eslint-disable jsx-a11y/no-static-element-interactions */
      _react2.default.createElement(
        'div',
        {
          className: (0, _reactUtils.classNames)('hs-pickadate', className),
          onKeyDown: this.handleKeyDown,
          onKeyUp: this.handleKeyUp,
          ref: this.refCallback
        },
        _react2.default.createElement(
          _UIPopover2.default,
          {
            animateOnMount: false,
            animateOnToggle: false,
            arrowSize: 'none',
            autoPlacement: 'vert',
            content: _react2.default.createElement('div', {
              className: (0, _reactUtils.classNames)('private-datepicker', datepickerClassName, {
                'private-datepicker--unclearable': !clearable
              }),
              ref: this.containerRefCallback
            }),
            open: this.state.isPickerOpen,
            pinToConstraint: true,
            placement: 'bottom right',
            use: 'unstyled',
            _bodyElement: _bodyElement
          },
          this.renderChild({
            children: children,
            error: error,
            format: format,
            maxValue: maxValue,
            minValue: minValue,
            placeholder: placeholder,
            readOnly: readOnly,
            rest: rest,
            value: value
          })
        )
      )
      /* eslint-enable jsx-a11y/no-static-element-interactions */

    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/input/abstract/UIAbstractDateInput.js
// module id = 372
// module chunks = 0